export default "__VITE_ASSET__NE7pTL99__"